"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAddEditableTextLayerToPrintable = void 0;
const typeguard_1 = require("../types/typeguard");
const PrintableAction_1 = require("./PrintableAction");
const layers_1 = require("../services/layers");
const addEditableTextLayerToPrintableRuleSet = {
  type: value => value === 'ADD_EDITABLE_TEXT_LAYER',
  activePage: (0, typeguard_1.optional)(value => Object.values(layers_1.CoverageType).some(v => v === value))
};
const isAddEditableTextLayerToPrintable = p => {
  return (0, PrintableAction_1.isPrintableAction)(p) && p && (0, typeguard_1.isType)(p, addEditableTextLayerToPrintableRuleSet);
};
exports.isAddEditableTextLayerToPrintable = isAddEditableTextLayerToPrintable;